import { render, staticRenderFns } from "./form-footer.vue?vue&type=template&id=87d9bc3a&"
import script from "./form-footer.vue?vue&type=script&lang=ts&"
export * from "./form-footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports